import { render, staticRenderFns } from "./rulenews.vue?vue&type=template&id=3250a209&scoped=true&"
import script from "./rulenews.vue?vue&type=script&lang=js&"
export * from "./rulenews.vue?vue&type=script&lang=js&"
import style0 from "./rulenews.vue?vue&type=style&index=0&id=3250a209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250a209",
  null
  
)

export default component.exports